// Role helpers — keep all role-based UI checks here so super_admin
// is always treated as having at least admin privileges.
//
// A "super_admin" can do everything an admin can PLUS hard-delete
// PAID tax invoices. Use `isAdminLike` when you want to gate any
// admin UI; use `isSuperAdmin` only for the elevated super-admin
// actions (e.g. promoting another admin, hard-deleting paid tax invoices).

export const isAdminLike = (user) =>
  Boolean(user) && (user.role === 'admin' || user.role === 'super_admin');

export const isSuperAdmin = (user) =>
  Boolean(user) && user.role === 'super_admin';

export const roleLabel = (role) => {
  if (role === 'super_admin') return 'Super Admin';
  if (role === 'admin') return 'Admin';
  if (role === 'user') return 'User';
  return role || 'Unknown';
};
